import './MobileBottomNav.css';
import { NavLink, useLocation } from 'react-router-dom';
import { useMainNav } from '../../context/MainNavContext';

type NavItemProps = {
    text: string;
    icon: React.ReactNode;
    path: string;
    active: boolean;
};

const MobileNavItem = ({ text, icon, path, active }: NavItemProps) => {
    const commonStyles = `mobile-nav-item${active ? ' nav-active' : ''}`;
    return (
        <NavLink to={path} className={commonStyles}>
            {icon}
            <p className='mobile-nav-item-text'>{text}</p>
        </NavLink>
    );
};

type Props = {
    isVisible: boolean;
};

const MobileBottomNav = ({ isVisible }: Props) => {
    const { mainNavItems } = useMainNav();
    const location = useLocation();
    const navItems = mainNavItems.map((item) => ({
        text: item.label,
        path: item.url,
        icon: <span className={item.icon}></span>
    }));

    const isNavItemActive = (path: string) => {
        if (path.includes('/analyzy/dochazka')) {
            return location.pathname.includes('/analyzy');
        }
        if (location.pathname === path) {
            return true;
        }
        return location.pathname.startsWith(`${path}/`);
    };

    return (
        <div className={`mobile-nav ${isVisible ? 'nav-visible' : 'nav-hidden'}`}>
            {navItems.map((item, index) => (
                <MobileNavItem key={index} {...item} active={isNavItemActive(item.path)} />
            ))}
        </div>
    );
};

export default MobileBottomNav;
